/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetEmploymentRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {GetEmploymentResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const getEmployment = (request: GetEmploymentRequest, options?: CashRequestOptions) => post<GetEmploymentRequest, GetEmploymentResponse>("/2.0/cash/get-employment", request, {...options, rejectOnError: true })